import { deprecated } from "typesafe-actions";

import type { IGenericServicesInfo } from "@/shop/types/services";

import { ServicesActionType } from "./constants";

const { createStandardAction } = deprecated;

export const fetchServices = createStandardAction(ServicesActionType.FETCH_SERVICES)();

export const fetchServicesStart = createStandardAction(ServicesActionType.FETCH_SERVICES_START)();

export const fetchServicesFail = createStandardAction(ServicesActionType.FETCH_SERVICES_FAIL)();

export const fetchServicesSuccess = createStandardAction(ServicesActionType.FETCH_SERVICES_SUCCESS).map(({ services }: IGenericServicesInfo) => ({
  payload: { services }
}));
